var path = '/shared/javascripts/templates/market_select.html';
var html = "<select ng-model=\"bindModel\" id='market-select-dropdown' ng-disabled='disabled'>\n  <option ng-repeat=\"market in markets\" value=\"{{ market.id }}\">\n    {{ market.displayName }}\n  </option>\n</select>";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;